module.exports = __webpack_public_path__ + "static/img/view7-1.2be2e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view7-1.png
// module id = ikgF
// module chunks = 1